var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center",staticStyle:{"min-height":"calc(100vh - 110px)","display":"flex"}},[_c('div',{staticStyle:{"align-self":"center","margin":"0 auto 7rem"}},[_c('cog-loader')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }